/* @flow */
import { Container } from 'flux/utils';
import React from 'react';

import ActivityComposerTooltip from 'payments/components/ActivityComposerTooltip.jsx';
import PromptActions from 'actions/PromptActions';
import PromptStore from 'stores/PromptStore';

export const PROMPT = 'web.composer.activity_banner';

type State = {
  hasDismissed: boolean,
};

class ActivityComposerTooltipContainer extends React.Component {
  state: State;

  static getStores() {
    return [
      PromptStore,
    ];
  }

  static calculateState() {
    return {
      hasDismissed: PromptStore.hasDismissed(PROMPT),
    };
  }

  render() {
    const actions = {
      dismiss: () => PromptActions.recordDismissal(PROMPT),
    };

    if (this.state.hasDismissed) {
      return <span />;
    }

    return <ActivityComposerTooltip {...this.props} {...actions} />;
  }
}

export default Container.create(ActivityComposerTooltipContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/payments/containers/ActivityComposerTooltipContainer.jsx